export default __webpack_public_path__ + "static/media/avatar_89.e3657f19.png";